module.exports = __webpack_public_path__ + "img/icon-filter-bottom.b1d03b77.svg";